import { useContext } from "react";
import { Box } from "@mui/material";
import Gauge from "./Gauge";
import { GlobalContext } from "../../../../common/Context";
import { boxShadow, text } from "../../../../../theme/colours";

const ScoreGauge = ({ title, score, width, type, boxed }) => {
  const { mobileView, tabletView } = useContext(GlobalContext);

  const boxStyle = {
    padding: "3%",
    background: "white",
    borderRadius: "10px",
    boxShadow: `inset 0px 3px 6px ${boxShadow}`,
    ...(tabletView && {
      width: "30%",
      height: "100%",
    }),
  };
  const textStyle = {
    fontFamily: "Poppins, sans-serif",
    fontWeight: 900,
    fill: text.primary,
    mb: "-1rem",
    textTransform: type === "total" && "uppercase",
    fontSize: mobileView && "1rem",
  };
  const titleStyle = {
    fontSize: boxed ? "0.875rem" : type === "total" ? "0.55rem" : "0.6rem",
    fontWeight: 700,
  };
  const valueStyle = {
    fontSize: boxed ? "0.875rem" : type === "total" ? "1.8rem" : "1.2rem",
  };

  isNaN(score) && (score = 0);

  return (
    <Box sx={boxed && { ...boxStyle }}>
      <Gauge
        title={title}
        value={score}
        width={width}
        type={type}
        titleStyle={{ ...textStyle, ...titleStyle }}
        valueStyle={{ ...textStyle, ...valueStyle }}
      />
    </Box>
  );
};

export default ScoreGauge;
